import { render, staticRenderFns } from "./Tipology.vue?vue&type=template&id=745b5acc&scoped=true&"
import script from "./Tipology.vue?vue&type=script&lang=js&"
export * from "./Tipology.vue?vue&type=script&lang=js&"
import style0 from "./Tipology.vue?vue&type=style&index=0&id=745b5acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b5acc",
  null
  
)

export default component.exports